import { render, staticRenderFns } from "./AddRandomBoxDialog.vue?vue&type=template&id=39d20ced&scoped=true&"
import script from "./AddRandomBoxDialog.vue?vue&type=script&lang=js&"
export * from "./AddRandomBoxDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d20ced",
  null
  
)

export default component.exports